import { useState } from 'react'
import {  Slider, Switch  } from 'antd'

const emails = {
  0: '0',
  100: '100',
  200: '200',
  300: '300',
  400: '400',
  500: {
    style: {
      color: '#47A1D9',
    },
    label: <strong>500</strong>,
  },
};

const sms = {
  0: '0',
  250: '250',
  500: '500',
  750: '750',
  1000: '1000',
  1250: '1250',
  1500: {
    style: {
      color: '#47A1D9',
    },
    label: <strong>1500</strong>,
  },
};

const llamadas = {
  0: '0',
  500: '500',
  1000: '1000',
  1500: '1500',
  2000: '2000',
  2500: {
    style: {
      color: '#47A1D9',
    },
    label: <strong>2500</strong>,
  },
};

const WebChat = {
  0: '0',
  500: '500',
  1000: '1000',
  1500: '1500',
  2000: '2000',
  2500: {
    style: {
      color: '#47A1D9',
    },
    label: <strong>2500</strong>,
  },
};

const IM = {
  0: '0',
  500: '500',
  1000: '1000',
  1500: '1500',
  2000: '2000',
  2500: {
    style: {
      color: '#47A1D9',
    },
    label: <strong>2500</strong>,
  },
};

const oparadores = {
  0: '0',
  500: '500',
  1000: '1000',
  1500: '1500',
  2000: '2000',
  2500: {
    style: {
      color: '#47A1D9',
    },
    label: <strong>2500</strong>,
  },
};

const SliderRangeCampaing = () => {
  const [disabledEmail, setDisabledEmail] = useState(true)
  const [disabledSms, setDisabledSms] = useState(true)
  const [disabledCall, setDisabledCall] = useState(true)
  const [disabledWebChat, setDisabledWebChat] = useState(true)
  const [disabledIM, setDisabledIM] = useState(true)
  const [disabledOperadores, setDisabledOperadores] = useState(true)

  return (
    <div>
       <div className="m-cols-2 mt-20 mb-20 form-inbount__range">
          <p className="source-16 bold">Emails</p> 
          <Switch className="mr-15" size="small" checked={!disabledEmail} onChange={() => setDisabledEmail(prevValue => !prevValue)} />
          <Slider marks={emails} disabled={disabledEmail} /*defaultValue={500}*/  max={500} onChange={value => console.log(value)}/>
        </div>

        <div className="m-cols-2 mt-20 mb-20 form-inbount__range">
          <p className="source-16 bold">Mensajes SMS: </p> 
          <Switch className="mr-15" size="small" checked={!disabledSms} onChange={() => setDisabledSms(prevValue => !prevValue)} />
          <Slider marks={sms} disabled={disabledSms} /*defaultValue={500}*/  max={1500} onChange={value => console.log(value)}/>
        </div>

        <div className="m-cols-2 mt-20 mb-20 form-inbount__range">
          <p className="source-16 bold">Llamadas telefónicas: </p> 
          <Switch className="mr-15" size="small" checked={!disabledCall} onChange={() => setDisabledCall(prevValue => !prevValue)} />
          <Slider marks={llamadas} disabled={disabledCall} /*defaultValue={500}*/  max={2500} onChange={value => console.log(value)}/>
        </div>

        <div className="m-cols-2 mt-20 mb-20 form-inbount__range">
          <p className="source-16 bold">WebChat: </p> 
          <Switch className="mr-15" size="small" checked={!disabledWebChat} onChange={() => setDisabledWebChat(prevValue => !prevValue)} />
          <Slider marks={WebChat} disabled={disabledWebChat} /*defaultValue={500}*/  max={2500} onChange={value => console.log(value)}/>
        </div>

        <div className="m-cols-2 mt-20 mb-20 form-inbount__range">
          <p className="source-16 bold">IM: </p> 
          <Switch className="mr-15" size="small" checked={!disabledIM} onChange={() => setDisabledIM(prevValue => !prevValue)} />
          <Slider marks={IM} disabled={disabledIM} /*defaultValue={500}*/  max={2500} onChange={value => console.log(value)}/>
        </div>

        <div className="m-cols-2 mt-20 mb-20 form-inbount__range">
          <p className="source-16 bold">Operadores: </p> 
          <Switch className="mr-15" size="small" checked={!disabledOperadores} onChange={() => setDisabledOperadores(prevValue => !prevValue)} />
          <Slider marks={oparadores} disabled={disabledOperadores} /*defaultValue={500}*/  max={2500} onChange={value => console.log(value)}/>
        </div>
    </div>
  )
}

export default SliderRangeCampaing
